import GradientBorderRadius from "@/ui/gradient-border-radius";
import Input from "@/ui/input";
import Avatar from "@/ui/avatar";
import { useToken } from "@/pages/token-v2/hooks/use-token";
import { formatDecimalStringFloat } from "@/utils/currency";

const BalanceTokenInputV2 = ({
  youSell,
  youSellPercentage,
  onYouSellChange,
  onYouSellPercentageChange,
}: {
  youSell: string;
  youSellPercentage: string;
  onYouSellChange: (v: string) => void;
  onYouSellPercentageChange: (v: string) => void;
}) => {
  const token = useToken();

  const tokenIcon = token?.icon ?? "";

  return (
    <GradientBorderRadius
      gradient="default-border"
      hover="r-100"
      className="focus-within:before:bg-gradient-100"
    >
      <div className="px-[0.625rem] h-[1.875rem] flex items-center justify-between">
        <Input
          value={youSell}
          activeWhenInputIsNotEmpty={false}
          gradient="none"
          hover="none"
          placeholder="0"
          gradientClassName="focus-within:before:bg-none"
          className="!h-[1.375rem]"
          onChange={(v) => {
            const formattedValue = formatDecimalStringFloat(v, true, false, 8);

            onYouSellChange(formattedValue);
          }}
          leftSide={
            <div className="w-[1.375rem] h-full flex items-center justify-center">
              <Input.Accordion>
                <Avatar size="input" source={tokenIcon} />
              </Input.Accordion>
            </div>
          }
        />
        <div className="flex items-center gap-x-[0.3125rem]">
          <div className="w-[5.125rem] text-xs">
            <Input
              value={youSellPercentage}
              activeWhenInputIsNotEmpty={false}
              gradient="none"
              hover="none"
              placeholder="0"
              gradientClassName="focus-within:before:bg-none"
              className="!text-opacity-50 h-[1.375rem] text-end"
              onChange={(v) => {
                if (Number(v) > 100 || Number(v) < 0) {
                  return;
                }

                const formattedValue = formatDecimalStringFloat(v, true, false);

                onYouSellPercentageChange(formattedValue);
              }}
              rightSide={
                <div className="h-[1.375rem]  flex items-center justify-center">
                  <Input.Accordion>%</Input.Accordion>
                </div>
              }
            />
          </div>

          <span
            onClick={() => onYouSellPercentageChange("100")}
            className="text-xs cursor-pointer"
          >
            MAX
          </span>
        </div>
      </div>
    </GradientBorderRadius>
  );
};

export default BalanceTokenInputV2;
